/** Only known checkout return surfaces can initiate receipt lookup. */
export function checkoutReceiptReturn(pathname: string, search: string): { sessionId: string; surface: string } | null {
  const sessionId = new URLSearchParams(search).get('session_id');
  if (!sessionId || !/^cs_[A-Za-z0-9_]{5,200}$/.test(sessionId)) return null;
  const surface = pathname === '/extension-checkout-return' && new URLSearchParams(search).get('status') === 'success' && new URLSearchParams(search).get('surface') !== 'desktop' ? 'extension_checkout'
    : pathname === '/welcome' ? 'desktop_welcome'
    : pathname === '/learn/checkout' || pathname === '/app/learn/checkout' ? 'learn_checkout'
    : /^\/account\/plan\/[^/]+\/checkout\/success\/?$/.test(pathname) ? 'account_plan'
    : pathname === '/account/billing' ? 'account_billing'
    : pathname === '/app/home' ? 'go_checkout'
    : pathname === '/docs' || pathname === '/app/docs' ? 'learn_legacy'
    : /^\/edu\/[^/]+\/?$/.test(pathname) ? 'edu_checkout' : null;
  return surface ? { sessionId, surface } : null;
}
